import{styled as o}from"styled-components";const e=o.select`
  font-family: Consolas;
  float: left;
  height: 21px;
  padding: 1px 4px;
  border: 1px solid #cccccc;
  border-top: 1px solid #666666;
  border-left: 1px solid #666666;
  border-radius: 3px;
  line-height: 22px;
  white-space: nowrap;
  vertical-align: middle;
  outline: none;
  background: none;
`;export{e as BaseSelect};
